import { SlideDown } from './slidedown'
import './slidedown/slidedown.css'
export const SlidingPanel = SlideDown
